import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import Dropzone from 'react-dropzone';
import { ToastsStore } from 'react-toasts';
import ProgressBar from 'react-bootstrap/ProgressBar';
import { v4 as uuidv4 } from 'uuid';

import cross from "../assets/img/cross.png";

import Loader from './Loader';
import { ReactComponent as IconFile } from "../assets/img/file.svg"
import { ReactComponent as IconUpload } from "../assets/img/uploadImg.svg"
import { headers } from '../utils/utils';

let BASE_URL;
if (/localhost/.test(window.location.host))
    BASE_URL = 'https://rec.api.lockself.com';
else
    BASE_URL = window.location.origin;

class SendDeposit extends Component {
    constructor(props) {
        super(props)

        this.state = {
            added: false,
            errorSend: false,
            errorSize: false,
            fileToUpload: {},
            isSent: false,
            status: null,
            filesToUpload: [],
            limitSize : (this.props.whitemarkMaxSize >= 1000 ? `${this.props.whitemarkMaxSize / 1000} Go` : `${this.props.whitemarkMaxSize} Mo`),
            selectedFiles: [],
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.files !== prevProps.files) {
            this.setState({
                filesToUpload: this.props.files
            })
        }
    }

    onDrop = (files) => {
        const { t } = this.props
        const filesToUpload = [...this.state.filesToUpload]

        for (let i = 0; i < files.length; i++) {

            // Check if no files exceed the maximum size.
            if (files[i].size > this.props.whitemarkMaxSize * 1000000) {
                this.setState( {
                    errorSize : true
                })
                ToastsStore.error(t("depositBox.fileTooBig"), 5000)
            } else {
                filesToUpload.push(files[i])
            }
        }

        if (filesToUpload.length > 0) {
            this.props.actions.onDrop(filesToUpload)
            this.setState({
                filesToUpload: filesToUpload?.map((fileToUpload, index) => {
                    if (!!fileToUpload?.id) {
                        fileToUpload.id = index + 1
                    } else {
                        Object.defineProperty(fileToUpload, 'id', {
                            value: index + 1,
                            writable: true
                        })
                    }

                    return fileToUpload
                })
            })
            this.uploadFileSimulator();
        }
    }

    displayListFiles = (files) => {
        return (
            <div className="fileListContainer">
                <ol className="fileList">
                    {files.map((file, index) => {
                        const isSelected = !!this.state.selectedFiles?.find(selectedFile => selectedFile?.id === file?.id)

                        return (<li className={`fileItem${isSelected ? ' isSelected' : ''}`} key={index} onClick={() => {
                            if (this.state.selectedFiles?.find(selectedFile => selectedFile?.id === file?.id)) {
                                this.setState({
                                    selectedFiles: this.state.selectedFiles?.filter(selectedFile => selectedFile?.id !== file?.id)
                                })
                            } else {
                                if (!!file?.id) {
                                    file.id = index + 1
                                } else {
                                    Object.defineProperty(file, 'id', {
                                        value: index + 1,
                                        writable: true
                                    })
                                }

                                this.setState({
                                    selectedFiles: [...this.state.selectedFiles, file]
                                })
                            }
                        }}>
                            <div className="checkBox"></div>
                            <IconFile className="icon" />
                            <p className="fileItemName" title={file.name}>{file.name}</p>
                            {/* <img src={cross} onClick={e => this.removeFileFromList(e, index)} alt="" /> */}
                        </li>)
                    })}
                </ol>
            </div>
        )
    }

    removeFileFromList = (e, index) => {
        if (index !== -1) {
            this.setState( { errorSize : false })
            this.setState({ errorSend: false });
            this.props.actions.removeFileFromList(index);
        }
    }

    uploadFileSimulator = () => {
        var fUpload = document.getElementById("fileUpload");
        var dAdd = document.getElementsByClassName("descAdd");
        fUpload.classList.add("reduced");
        dAdd[0].classList.remove("reduced");
        this.setState({
            added: true
        })
    }

    addNewDepoFile = (newFile, t, whitemarkMaxSize) => {
        //e.preventDefault();
        newFile.t = t;
        newFile.whitemarkMaxSize = whitemarkMaxSize;

        if (newFile.length === 0) {
            this.setState( { errorSize : false })
            this.setState({
                errorSend: true,
            });
        }
        else {
            var loaderWrapper = document.getElementsByClassName("loader-wrapper");
            loaderWrapper[0].style.display = "block";
            loaderWrapper[0].style.opacity = 1;
            //this.props.actions.addNewDepoFile(newFile);
            this.uploadFile();
        }
    }

    isAddedFiles = (files, t) => {
        if (this.state.added && files.length === 1) {
            return (
                <div className="filesAdded">
                    <p className="sendDepositP">{t("depositBox.fileAdded")}</p>
                    <p className="sendDepositP">{files.length} {t("depositBox.file")}</p>
                </div>
            )
        }
        else if (this.state.added && files.length > 1) {
            return (
                <div className="filesAdded">
                    <p className="sendDepositP">{t("depositBox.fileAddedPlu")}</p>
                    <p className="sendDepositP">{files.length} {t("depositBox.filePlu")}</p>
                </div>
            )
        }
        else {
            return (
                <p className="sendDepositP">{t("depositBox.file")}</p>
            )
        }
    }

    msgFiles = (files, t) => {
        return (
            <div className={`msgFilesContainer${(!this.state.added || files.length === 0) ? "" : " isReduced"}`}>
                <p className="sendDepositP" dangerouslySetInnerHTML={{ __html: t("depositBox.clickHere") }} />
                <IconUpload className="icon" />
                <p className="sendDepositP add">{t("depositBox.addFile", { limitSize : this.state.limitSize })}</p>
            </div>
        )
    }

    selectAllFiles = () => {
        this.setState({
            selectedFiles: this.props.files?.map((fileToUpload, index) => {
                if (!!fileToUpload?.id) {
                    fileToUpload.id = index + 1
                } else {
                    Object.defineProperty(fileToUpload, 'id', {
                        value: index + 1,
                        writable: true
                    })
                }

                return fileToUpload
            })
        })
    }

    cancelFileSelection = () => {
        this.setState({
            selectedFiles: []
        })
    }

    removeFromFilesToUpload = (ids) => {
        this.props.actions.removeFileFromUploadsList(ids)
        this.setState({
            selectedFiles: [],
            added: ids?.length !== this.props.files?.length,
        })
    }

    yourDesc = (files, t) => {
        return (
            <div id="descAdd" className={files.length === 0 ? "uploadStep descAdd reduced" : "uploadStep descAdd extend"}>
                <div className='containerDesc'>
                    {<div className="blocListFile">
                        <h5 className="headList">{t("depositBox.readyToDeposit")}&nbsp;({files?.length})</h5>
                        {this.displayListFiles(files)}
                        {<div className="filesListActions">
                            {(this.state?.selectedFiles?.length < files?.length) && <button className="actionBtn" onClick={() => this.selectAllFiles()}>{t('depositBox.selectAll')}</button>}
                            {this.state?.selectedFiles?.length > 0 && <button className="actionBtn" onClick={() => this.cancelFileSelection()}>{t('depositBox.cancelSelection')}</button>}
                        </div>}
                    </div>}
                    {this.state.selectedFiles?.length > 0 && (
                        <div className="selectedFileContainer">
                            <div className="fileContent">
                                {this.state.selectedFiles?.length === 1 && <p className="fileName" title={this.state.selectedFiles?.[0]?.name}>{this.state.selectedFiles?.[0]?.name}</p>}
                                {this.state.selectedFiles?.length > 1 && <p className="fileCount">{`(${this.state.selectedFiles?.length})`}&nbsp;{t('depositBox.selectedFileName')}</p>}
                            </div>
                            <button className="removeFileToUpload" onClick={() => this.removeFromFilesToUpload(this.state.selectedFiles?.map(file => file.id))}>{t('depositBox.removeFile')}</button>
                        </div>
                    )}
                    <textarea id="taDesc" placeholder={t("depositBox.typeHere")} className={`${this.state.selectedFiles?.length <= 0 ? "" : "isHidden"}`}></textarea>
                </div>
            </div>
        )
    }

    dropFiles = (files, t) => {
        return (
            <Dropzone id="dropzone-zone" onDrop={acceptedFiles => { this.onDrop(acceptedFiles) }}>
                {({ getRootProps, getInputProps }) => {
                    return (
                        <div {...getRootProps()} id="fileUpload" className={files.length === 0 ? "uploadStep fileUpload extend" : "uploadStep fileUpload reduced"}>
                            <div className="fileUploadContent">
                                <input {...getInputProps()} id="fileUploadInput" />
                                {this.msgFiles(files, t)}
                            </div>
                        </div>
                    )
                }}
            </Dropzone>
        )
    }

    index = (index) => {
        return index;
    }

    uploadFile = async () => {

        let that = this;

        function handleComplete(totalChunkCount, index, count, files) {
            if (totalChunkCount - 1 === index && count === that.props.files.length - 1) {
                document.getElementsByClassName("loader-wrapper")[0].style.display = "none";
                document.getElementsByClassName("loader-wrapper")[0].style.opacity = 0;
                that.props.updateListFiles(files);
                that.props.actions.setValueSelect("plusRecent");
                that.props.displayConsultBox()
            }
        }

        const chunkSize = 20000000;
        let description = document.getElementById("taDesc")?.value
        for (let count = 0; count < this.props.files.length; count++) {

            const totalChunkCount = Math.ceil(this.props.files[count].size / chunkSize);
            let uuid = uuidv4();

            for (let chunkIndex = 0; chunkIndex < totalChunkCount; chunkIndex++) {
                let resStatus = null;
                let offset = chunkIndex * chunkSize;
                let blob = this.props.files[count].slice(offset, offset + chunkSize);
                let filePart = new File([blob], this.props.files[count].name);

                const data = new FormData();
                data.append("file", filePart, this.props.files[count].name);
                data.append("depositBoxId", this.props.id);
                data.append("uuid", uuid);
                data.append("chunkIndex", chunkIndex);
                data.append("totalChunkCount", totalChunkCount);
                data.append("emails", this.props.loggedUser?.email);
                data.append("totalSize", this.props.files[count].size);
                data.append("description", description);
                data.append("hash1", this.props.boxHash1);
                data.append("hash2", this.props.boxHash2);
                data.append("uh1", this.props.userHash1);
                data.append("uh2", this.props.userHash2);
                data.append("token", this.props.tokenUrl ?? this.props.userToken);
                data.append("sendEmail", (this.props.files.length === 1 ? 1 : count+1 === this.props.files.length ? 1 : 0) );
                if (this.props.isProtected) {
                    data.append("passwordDb", localStorage.getItem("password"))
                }

                /*var xhr = new XMLHttpRequest();
                xhr.open('POST', `${BASE_URL}/api/external/depositboxes/upload`)
                //xhr.setRequestHeader("Content-Type", "multipart/form-data")
                xhr.send(data)

                xhr.onreadystatechange = function(oEvent) {
                    if(xhr.readyState === 4) {
                        //if(xhr.status === 201) {
                            var res = JSON.parse(this.response);
                            handleComplete(totalChunkCount, chunkIndex, count, res.files)
                        //}

                    }
                }*/

                await fetch(`${this.props.baseUrl}/api/external/depositboxes/upload`, { method: "POST", headers: headers({ formData: true }), body: data })
                    .then((res) => {
                        this.setState({
                            status: res.status
                        })
                        resStatus = res.ok;
                        return res.json();
                    }).then((res) => {
                        if (resStatus && totalChunkCount - 1 === chunkIndex && count === this.props.files.length - 1) {
                            document.getElementsByClassName("loader-wrapper")[0].style.display = "none";
                            document.getElementsByClassName("loader-wrapper")[0].style.opacity = 0;
                            this.props.updateListFiles(res.files);
                            this.props.actions.setValueSelect("plusRecent");
                            this.props.displayConsultBox()
                        }
                    })
                    .catch(function (error) {
                        console.log('error = ', error)
                        if (error.response) {
                            console.log("ERROR RESPONSE")
                            // The request was made and the server responded with a status code
                            // that falls out of the range of 2xx
                            console.log("ERROR RESPONSE DATA = ", error.data);
                            console.log("ERROR RESPONSE STATUS = ", error.response.status);
                            console.log("ERROR RESPONSE HEADERS = ", error.response.headers);
                        } else if (error.request) {
                            console.log("ERROR REQUEST")
                            // The request was made but no response was received
                            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                            // http.ClientRequest in node.js
                            console.log(error.request);
                        } else {
                            console.log("ERROR OTHER")
                            // Something happened in setting up the request that triggered an Error
                            console.log('Error', error.message);
                        }
                    })
            }
        }
    }

    render() {
        const { t } = this.props;
        var checkDesc = document.getElementById("checkDesc");
        if (this.props.isSent) {
            checkDesc.setAttribute("class", "checked");
        }

        return (
            <div className={`sendDiv${this.state.added ? " filesAdded" : ""}`} id="sendDiv">
                {this.dropFiles(this.props.files, t)}
                {this.props.files?.length > 0 && (
                    <>
                        {this.yourDesc(this.props.files?.map((fileToUpload, index) => {
                            if (!!fileToUpload?.id) {
                                fileToUpload.id = index + 1
                            } else {
                                Object.defineProperty(fileToUpload, 'id', {
                                    value: index + 1,
                                    writable: true
                                })
                            }

                            return fileToUpload
                        }), t)}
                        {this.props.loadPercent > 0 && <ProgressBar now={this.props.loadPercent} color="#f47532" srOnly label={this.props.almostReady ? t("general.cryptFile") : this.props.loadPercent + "%"} animated />}
                        {this.props.loadPercent > 0 && <div className="progress-label">
                            <p className="progress-label-p">{this.props.almostReady ? t("general.cryptFile") : this.props.loadPercent + "%"}</p>
                        </div>}
                    </>
                )}
                <div className="uploadBtn">
                    {this.props.removeClickable === false ? <button id="addFile" className={`greyBtn${this.props.files?.length > 0 ? " isActive" : ""}`} onClick={e => {
                        if (this.props.files?.length > 0) {
                            this.addNewDepoFile(this.props.files, t, this.props.whitemarkMaxSize)
                        }
                    }}>{t("depositBox.sendBtn")}</button> : null}
                </div>
                <Loader />
            </div>
        )
    }
}

export default withTranslation()(SendDeposit)
